export const maskedKey = "•".repeat(13);

export const getTruncatedString = (data: string): string => {
  const apiKeyLength = data.length;
  const keyToArray = data.split("");

  const truncatedKeyWithCentreEllipses = [
    ...keyToArray.slice(0, 5),
    "...",
    ...keyToArray.slice(apiKeyLength - 5),
  ];

  return truncatedKeyWithCentreEllipses.join("");
};

export const apiKeyToTruncatedAuthorizationHeader = (key: string) =>
  "Basic " + getTruncatedString(Buffer.from(key).toString("base64"));

export const apiKeyToAuthorizationHeader = (key: string) =>
  "Basic " + Buffer.from(key).toString("base64");
